module.exports = __webpack_public_path__ + "static/media/d4.867c989f.jpg";